import PropTypes from 'prop-types';

const allowedListItemProps = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ]).isRequired,
  classNames: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.string
    ),
    PropTypes.func
  ]),
  image: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func
  ]),
  caption: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.func
  ]),
  cardSize: PropTypes.oneOf([
    'small',
    'medium',
    'big'
  ]),
  cardMargin: PropTypes.oneOf([
    'small',
    'medium',
    'big'
  ])
};

export {
  allowedListItemProps
};